"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _styled = require("./styled.js");

var _Utils = require("./helpers/Utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellQuestion = function CellQuestion(props) {
  var withImage = props.withImage,
      Link = props.Link,
      type = props.type,
      header = props.header,
      headerText = props.headerText,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      noLink = props.noLink,
      _props$printView = props.printView,
      printView = _props$printView === void 0 ? false : _props$printView;
  var _props$data = props.data,
      question = _props$data.question,
      text = _props$data.text,
      to = _props$data.to,
      image_url = _props$data.image_url,
      num_content = _props$data.num_content;
  var questionText = question || text;

  if (!header && !(0, _Utils.validateString)(questionText) && !(0, _Utils.validateString)(to)) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  var headerContent = headerText || type;
  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    type: type,
    width: width,
    sortable: sortable,
    sortOrder: sortOrder
  }, headerContent) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    width: width,
    height: "100%"
  }, withImage ? /*#__PURE__*/_react["default"].createElement(_styled.StyledCellQuestion, null, image_url ? /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
    url: image_url,
    opacity: "0.3"
  }) : /*#__PURE__*/_react["default"].createElement(_styled.QuestionPlaceholderImage, null)) : null, /*#__PURE__*/_react["default"].createElement(_styled.StyledCellTextContainer, {
    withImage: withImage
  }, noLink ? questionText : /*#__PURE__*/_react["default"].createElement(Link, {
    className: "contentName",
    to: to
  }, questionText), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    fontSize: printView ? '6px' : '10px',
    lineHeight: printView ? '8px' : '18px',
    color: "#939AAB"
  }, /*#__PURE__*/_react["default"].createElement(_styled.NumUnitIcon, null), " ", num_content)));
};

var _default = CellQuestion;
exports["default"] = _default;

//# sourceMappingURL=CellQuestion.js.map